import {
  TIME_LINE_MODE,
  TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT,
  TIME_LINE_OBJECT_X_CELL_MIN_WIDTH,
} from '@constants'
import { TimeLineDTOType } from '@types'

export const enrichConfigWithDefaultValues = (data: TimeLineDTOType): TimeLineDTOType => {
  return {
    ...data,
    mode: data.mode || TIME_LINE_MODE.DATE_TIME,
    objectX: {
      ...data.objectX,
      cell: {
        ...data.objectX.cell,
        minWidth: data.objectX.cell.minWidth || TIME_LINE_OBJECT_X_CELL_MIN_WIDTH,
        minHeight: data.objectX.cell.minHeight || TIME_LINE_OBJECT_X_CELL_MIN_HEIGHT,
      },
    },
  }
}
